import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: theme => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    vertical-align: center;
    position: relative;
    width: 100%;
    padding: 0 ${theme.spacing.xs};
    width: calc(100% - ${theme.spacing.xs});
    height: calc(100vh - 220px);
    @media screen and (max-height: ${theme.grid.breakpoint.md}) {
      height: 100%;
    }
  `,

  loginForm: theme => css`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;

    max-width: 360px;
    width: 100%;
    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      width: 100%;
      margin: ${theme.spacing.xxs} 0;
    }
  `,

  logoWhiteLabel: ({ spacing }) => css`
    width: 10rem;
    margin-bottom: ${spacing.xxs};
  `,

  subtitleLoginInstructions: theme => css`
    color: ${theme.colors.neutral[200]};
    margin: ${theme.spacing.xs} 0 ${theme.spacing.md} 0;
  `,

  containerFirstInput: theme => css`
    margin-bottom: ${theme.spacing.xs};
  `,

  linkSupport: theme => css`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: ${theme.spacing.xs};
    font-size: ${theme.fontSizes.sm};
  `,

  linkSupportStart: theme => css`
    width: 100%;
    text-align: center;
    margin-top: ${theme.spacing.md};
    cursor: pointer;
    font-size: ${theme.fontSizes.sm};
  `,

  linkLogin: theme => css`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: ${theme.spacing.xxs};
    margin-bottom: ${theme.spacing.xs};
    > span {
      font-size: ${theme.fontSizes.sm};
    }
  `,

  buttonsWrapper: theme => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.xxs};
  `,

  divider: theme => css`
    margin: 0 ${theme.spacing.xxs};
    color: ${theme.colors.brand.secondary[300]};
  `,

  containerIcon: css`
    height: 100vh;
    flex-direction: row;
    display: flex;
    position: relative;
    @media screen and (max-width: 768px) {
      align-items: center;
      height: auto;
      width: 100%;
      align-items: center;
    }
  `,

  containerBackground: theme => css`
    position: relative;
    width: 65%;
    height: 100vh;

    background: linear-gradient(
      -45deg,
      ${theme.colors.brand.primary[300]},
      ${theme.colors.brand.primary[500]}
    );
    background-size: 400% 400%;
    animation: gradient 10s ease infinite;

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }

    @media screen and (max-width: ${theme.grid.breakpoint.md}) {
      width: 100%;
      height: 100vh;
    }
  `,
})

export default useStyles
